<template>
  <div class="rigth_Infwarp">
    <el-card style="height:100%">
      <p>各年龄段男女性别比</p>
      <div class="infro" ref="MyEcharts"></div>
    </el-card>
  </div>
</template>

<script>
import { ageInfoData } from "@/network";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.dataValueData();
  },
  methods: {
    async dataValueData() {
      const { code, data, msg } = await ageInfoData();
      if (code == 200) {
        let getInfo = {
          cnt: [],
          cnt2: [],
          cnt3: [],
          house: [],
          title: [],
        };
        for (const item of data) {
          getInfo.cnt.push(item.cnt);
          getInfo.cnt2.push(item.cnt2);
          getInfo.cnt3.push(item.cnt3);
          getInfo.house.push(item.house);
          let val = getInfo.title.indexOf(item.title);
          if (val == -1) {
            getInfo.title.push(item.title, item.title2, item.title3);
          }
        }
        this.getInfo(getInfo);
      }
    },
    getInfo(getInfo) {
      let myehcarts = this.$echarts.init(this.$refs.MyEcharts);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: getInfo.title,
        },
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: getInfo.house,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: getInfo.title[0],
            type: "bar",
            // barGap: 0,
            barWidth: 40,
            emphasis: {
              focus: "series",
            },
            data: getInfo.cnt,
            itemStyle: {
              normal: {
                color: "#E10019",
              },
            },
          },
          {
            name: getInfo.title[1],
            barWidth: 40,
            type: "bar",
            emphasis: {
              focus: "series",
            },
            data: getInfo.cnt2,
            itemStyle: {
              normal: {
                color: "#FFD200",
              },
            },
          },
          {
            barWidth: 40,
            name: getInfo.title[2],
            type: "bar",
            emphasis: {
              focus: "series",
            },
            data: getInfo.cnt3,
            itemStyle: {
              normal: {
                color: "#004EFF",
              },
            },
          },
        ],
      };
      myehcarts.setOption(option);
    },
  },
};
</script>

<style lang="less">
.rigth_Infwarp {
  height: 500px;
  margin: 10px 0;
  .el-card__body {
    height: 100%;
    .infro {
      height: 90%;
    }
  }
}
</style>
